import * as React from "react";
import Grid from "../grid/grid";
import GridItem from "../grid/griditem";
import Button from "./button";
import FlexContainer from "../grid/flexcontainer";
import { componentTranslations } from "./i18n";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const revoHeaderClass = css({
    backgroundColor: getThemeColorVar("background", "lighter"),
    minHeight: "184px",
    paddingLeft: "40px",
    paddingRight: "40px",
});
const revoHeaderOnlyTextClass = css({
    backgroundColor: getThemeColorVar("background", "lighter"),
    minHeight: "80px",
    paddingLeft: "40px",
    paddingRight: "40px",
});
const toolbarClass = css({
    marginTop: "24px",
    marginBottom: "24px",
});
const toolbarSeparatorClass = css({
    height: "24px",
    width: "1px",
    backgroundColor: getThemeColorVar("typo", "lighter"),
});
const titleClass = css({
    color: getThemeColorVar("typo", "dark"),
    fontSize: "40px",
    lineHeight: "40px",
    fontWeight: 300,
    minHeight: "40px",
});
const contentClass = css({
    marginTop: "40px",
    marginBottom: "40px",
});
const actionsClass = css({
    marginBottom: "40px",
});
export const RevoHeader = (props) => {
    const { title, backLabel, onBackAction, toolbarButtons, children, actions } = props;
    const t = componentTranslations();
    if (onBackAction || toolbarButtons || children) {
        return (React.createElement("div", { className: cx(revoHeaderClass) },
            React.createElement(Grid, { columns: 1 },
                React.createElement("div", { className: cx(toolbarClass) },
                    React.createElement(Grid, { columns: onBackAction && toolbarButtons ? 2 : 1 },
                        onBackAction && (React.createElement(GridItem, { justifySelf: "start" },
                            React.createElement(Button, { onClick: onBackAction, icon: "back", type: "tertiary" }, backLabel || t.revoHeader.backButton))),
                        toolbarButtons && (React.createElement(GridItem, { justifySelf: "end" },
                            React.createElement(FlexContainer, { spaceBetween: "lg", "md-align": "center" }, toolbarButtons
                                .map((props, index) => (React.createElement(Button, { key: index * 2, type: "tertiary", icon: props.icon, onClick: props.onClick, title: props.title, disabled: props.disabled })))
                                .map((button, index, array) => index === array.length - 1
                                ? button
                                : [
                                    button,
                                    React.createElement("span", { key: index * 2 + 1, className: cx(toolbarSeparatorClass) }),
                                ])))))),
                React.createElement(Grid, { columnSpec: actions
                        ? [
                            [2, "fr"],
                            [1, "fr"],
                        ]
                        : [[1, "fr"]] },
                    React.createElement("div", { className: cx(titleClass) }, title),
                    actions && (React.createElement(GridItem, { rowSpan: 2, alignSelf: "end", justifySelf: "end" },
                        React.createElement("div", { className: cx(actionsClass) }, actions))),
                    React.createElement("div", { className: cx(contentClass) }, children)))));
    }
    else {
        return (React.createElement("div", { className: cx(revoHeaderOnlyTextClass) },
            React.createElement(Grid, { columnSpec: actions
                    ? [
                        [2, "fr"],
                        [1, "fr"],
                    ]
                    : [[1, "fr"]], height: [80, "px"] },
                React.createElement(GridItem, { alignSelf: "center" },
                    React.createElement("div", { className: cx(titleClass) }, title)),
                actions && (React.createElement(GridItem, { alignSelf: "center", justifySelf: "end" }, actions)))));
    }
};
export default RevoHeader;
//# sourceMappingURL=revo-header.js.map